import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {UserService} from '../_services/user.service';
import {User} from '../_models/user';
import { ToastrService } from 'ngx-toastr';
import {ActivatedRoute, Router} from '@angular/router';
import {error} from 'util';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  user: User;
  returnUrl: string;

  constructor(private formBuilder: FormBuilder,
              private userService: UserService,
              private toastr: ToastrService,
              private route: ActivatedRoute,
              private router: Router
  ) { }

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      email: ['', Validators.compose([Validators.required, Validators.email])],
      password: ['', Validators.required]
    });

    this.userService.logout();

    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }

  onSubmit() {
    if (this.loginForm.valid) {
      this.userService.login(
        this.loginForm.controls.email.value,
        this.loginForm.controls.password.value).subscribe(
          response => {
                        if (response.mfa_required) {
                          this.router.navigate(['/login/otp'], { queryParams: { returnUrl: this.returnUrl } });
                        } else {
                          this.user = response;
                          this.router.navigate([this.returnUrl]);
                          this.toastr.success('Logged in successfully');
                        }
                       },
          err => {
            
            this.toastr.error(err.error.error);
          });
    } else {
      Object.keys(this.loginForm.controls).forEach(key => {
        this.loginForm.get(key).markAsDirty();
      });
    }
  }

}
